import { Trans, useTranslation } from "react-i18next";
import { Box, Stack, theme } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";

const PanelCommonError = () => {
    const { t } = useTranslation();

    return (
        <Box className={"box-permission"} textAlign="center">
            <Box>
                <i className="sprite sprite-error-permission" />
            </Box>
            <Stack direction={"column"} gap={theme.spacing(2)} my={theme.spacing(2)}>
                <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
                    {t(`common::msg::An error has occurred`, `An error has occurred`)}
                </Typography>
                <Typography variant={"body1_300"}>
                    <Trans
                        i18nKey="common::msg::If the problem persists, <0/> please contact the administrator."
                        components={[<br key="br" />]}
                    />
                </Typography>
            </Stack>
        </Box>
    );
};

export default PanelCommonError;
